<template>
  <div class="institutions-list-columns-column">
    <div class="institutions-list-card">
      <div class="institutions-list-card-header">
        <div class="institutions-list-avatar">
          <BaseAvatar
            :src="institution.photo"
            :text="getInitials(institution.name)"
            size="xl"
          />
        </div>
        <div class="institutions-list-info">
          <h4 class="institutions-list-info-title">
            {{ institution.name }}
          </h4>
          <p class="institutions-list-info-description">
            {{ institution.description }}
          </p>

          <BaseButton
            variant="card"
            size="lg"
            @click="onSchedule(institution.id)"
          >
            Agendar
          </BaseButton>
        </div>
      </div>

      <div class="institutions-list-card-body">
        <div class="institutions-list-tabs">
          <BTabs content-class="mt-3">
            <BTab
              v-for="(unit, idx) in institution.units"
              :key="unit.d"
              title="First"
              active
            >
              <template #title>
                <span>
                  <BaseIcon icon="pin" size="sm" color="#343a40" />
                  Unidade {{ idx + 1 }}
                </span>
              </template>
              <h6 class="institutions-list-subtitle">
                {{ unit.name }}
              </h6>
              <p class="institutions-list-text">
                {{ unitAddress(unit) }}
              </p>
            </BTab>
          </BTabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNameInitials } from "../../utils/getNameInitials";

export default {
  name: "InstitutionListCard",
  props: {
    institution: {
      type: Object,
      default: () => {}
    },
    institutionType: {
      type: String,
      default: ""
    }
  },
  methods: {
    getInitials(name) {
      return getNameInitials(name);
    },
    unitAddress(unit) {
      const {
        street,
        street_number,
        neighborhood,
        city,
        state,
        zip_code
      } = unit.address;
      return `${street}, ${street_number}, ${neighborhood}, ${city} - ${state}, CEP: ${zip_code}.`;
    },
    onSchedule(id) {
      this.$router.push({
        path: `/clinicas/${id}/agendamento?institution_type=${this.institutionType}`
      });
    }
  }
};
</script>
